import { useEffect } from "react";


function PageGuard() {
  useEffect(() => {
    const ATTR = "data-page-guard";

    document.documentElement.setAttribute(ATTR, "true");

    // Scoped styles for protection
    const style = document.createElement("style");
    style.setAttribute(ATTR, "true");
    style.textContent = `
      [${ATTR}="true"] body,
      [${ATTR}="true"] img,
      [${ATTR}="true"] video {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-user-drag: none;
        -webkit-touch-callout: none;
      }
      [${ATTR}="true"] {
        touch-action: pan-x pan-y;
      }
      .__page_guard_overlay__ {
        position: fixed;
        inset: 0;
        background: #000;
        z-index: 2147483647;
        display: none;
      }
      [${ATTR}="true"].__page_guard_hidden__ .__page_guard_overlay__ {
        display: block;
      }
    `;
    document.head.appendChild(style);

    // Black overlay for screenshot deterrence
    const guard = document.createElement("div");
    guard.className = "__page_guard_overlay__";
    guard.setAttribute(ATTR, "true");
    document.body.appendChild(guard);

    // Lock viewport zoom on mobile
    const viewport = document.querySelector('meta[name="viewport"]');
    const previousViewport = viewport ? viewport.getAttribute("content") : null;
    if (viewport) {
      viewport.setAttribute(
        "content",
        "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no"
      );
    }

    // Event handlers
    const onContextMenu = (e) => e.preventDefault();

    const onDragStart = (e) => {
      const tag = e.target?.tagName;
      if (tag === "IMG" || tag === "VIDEO") {
        e.preventDefault();
      }
    };

    const onKeyDown = (e) => {
      const key = (e.key || "").toLowerCase();
      const ctrl = e.ctrlKey || e.metaKey;

      // PrintScreen
      if (key === "printscreen" || e.keyCode === 44) {
        try {
          navigator.clipboard?.writeText("");
        } catch {}
        e.preventDefault();
        return;
      }

      // F12 DevTools
      if (key === "f12") {
        e.preventDefault();
        return;
      }

      if (!ctrl) return;

      // Zoom: Ctrl + - = 0
      if (["+", "-", "=", "0"].includes(key)) {
        e.preventDefault();
        return;
      }

      // Save, Print, View Source
      if (["s", "p", "u"].includes(key)) {
        e.preventDefault();
        return;
      }

      // DevTools: Ctrl+Shift+I/J/C
      if (e.shiftKey && ["i", "j", "c"].includes(key)) {
        e.preventDefault();
      }
    };

    const onWheel = (e) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    };

    const onTouchMove = (e) => {
      if (e.touches?.length > 1) {
        e.preventDefault();
      }
    };

    const onGesture = (e) => e.preventDefault();

    const showGuard = () => {
      document.documentElement.classList.add("__page_guard_hidden__");
    };
    const hideGuard = () => {
      document.documentElement.classList.remove("__page_guard_hidden__");
    };
    const onVisibility = () => {
      if (document.hidden) showGuard();
      else hideGuard();
    };

    // Register listeners
    document.addEventListener("contextmenu", onContextMenu);
    document.addEventListener("dragstart", onDragStart);
    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("wheel", onWheel, { passive: false });
    document.addEventListener("touchmove", onTouchMove, { passive: false });
    document.addEventListener("gesturestart", onGesture);
    document.addEventListener("gesturechange", onGesture);
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("blur", showGuard);
    window.addEventListener("focus", hideGuard);

    // Harden media elements
    const hardenMedia = () => {
      document.querySelectorAll("video").forEach((v) => {
        v.setAttribute("controlsList", "nodownload noplaybackrate");
        v.setAttribute("disablePictureInPicture", "true");
      });
      document.querySelectorAll("img").forEach((img) => {
        img.setAttribute("draggable", "false");
      });
    };
    hardenMedia();
    const observer = new MutationObserver(hardenMedia);
    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup on unmount
    return () => {
      document.removeEventListener("contextmenu", onContextMenu);
      document.removeEventListener("dragstart", onDragStart);
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("wheel", onWheel, { passive: false });
      document.removeEventListener("touchmove", onTouchMove, { passive: false });
      document.removeEventListener("gesturestart", onGesture);
      document.removeEventListener("gesturechange", onGesture);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("blur", showGuard);
      window.removeEventListener("focus", hideGuard);

      observer.disconnect();

      document.documentElement.classList.remove("__page_guard_hidden__");
      document.documentElement.removeAttribute(ATTR);

      style.remove();
      guard.remove();

      if (viewport) {
        if (previousViewport !== null) {
          viewport.setAttribute("content", previousViewport);
        } else {
          viewport.removeAttribute("content");
        }
      }
    };
  }, []);

  return null;
}

export default PageGuard;
